function reload() {
  window.location.reload()
}

export default function ButtonReload() {
  return (
    <button
      type="button"
      className={`
        relative
        overflow-visible
        flex items-center content-between
        min-w-max
        w-32 md:w-48
        py-3.5 pr-2 pl-3 md:py-3 md:px-4
        rounded
        bg-transparent
        text-[14px] md:text-[18px]
        leading-[1.8em]

        box-border
        border border-black

        md:transition-[border]
        md:duration-300
        md:ease-linear
        md:hover:opacity-100
        md:hover:border-[1.5px]
        md:[&_span]:hover:text-bold
        md:[&_span]:hover:transform-[scale(1.047,1.047)]
        md:[&_path]:hover:stroke-[2.5]
        md:[&_i]:hover:opacity-60
      `}
      onClick={reload}
    >
      <span className="transition-all duration-300 ease-linear">
        &nbsp;リロードする&nbsp;
      </span>

      <i
        className={`
          block
          absolute z-0
          top-3 right-7
          size-7
          bg-theme-main
          opacity-0
          rounded-full
          blur-lg
          md:transition-opacity
          md:duration-300
          md:ease-linear
        `}
      />

      <span className="size-6">
        <img src="/images/common/icon_reload.svg" alt="reload" />
      </span>
    </button>
  )
}
